import { render, staticRenderFns } from "./ADashboard.vue?vue&type=template&id=5ecc0a9e&scoped=true"
import script from "./ADashboard.vue?vue&type=script&lang=js"
export * from "./ADashboard.vue?vue&type=script&lang=js"
import style0 from "./ADashboard.vue?vue&type=style&index=0&id=5ecc0a9e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecc0a9e",
  null
  
)

export default component.exports